import styled, { css } from 'styled-components'
import Media from 'builder/styles/media'
import ConversationalBuilder from 'builder/features/conversationalBuilder/ConversationalBuilder'
import { FloatingButton } from '../styles'

export const FloatingButtonComponent = styled(FloatingButton)<{ $aiWriterOpen?: boolean }>`
  left: 50%;
  position: absolute;
  transform: translate(-50%, 0);
  transition: all 350ms ease-in-out;

  ${props =>
    props.$aiWriterOpen &&
    css`
      visibility: hidden;
      opacity: 0;
    `}
`

export const ConversationalBuilderComponent = styled(ConversationalBuilder)`
  z-index: 3;
  width: 100%;
  position: absolute;

  ${Media.Tablet`
    top: 0;
    position: fixed;
    // This is set to 201 to be above the mobile avatar menu
    z-index: 201;
    height: 100vh;
  `}
`
